import { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import {
  ButtonBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  Paper,
} from '@material-ui/core';
import { connect } from 'react-redux';
import _ from 'lodash';
import rou from '../../../../router';
import Header from '../RosterPlanner/head';
import { Head } from '../RosterPlanner';
import { SettingIcon, DropDownIcon } from '../../../../components/Icon';
import { Dialog } from '../../../../components';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import DatePicker from '../Header/DatePicker';
import leaveCode from './leaveCode';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '2.063rem',
    width: '100%',
  },
  body: {
    padding: '6.25rem 3.438rem 0',
    background: theme.palette.font.white,
    position: 'relative',
    minHeight: 'calc(100vh - 4.375rem)',
  },
  headBtn: {
    padding: '0 1.063rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
  },
  container: {
    maxHeight: 'calc(100vh - 15.875rem)',
  },
  setting: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.125rem',
    lineHeight: '1.875rem',
    letterSpacing: 0,
    height: '6rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    backgroundColor: theme.palette.font.white,
  },
  tableTr: {
    '&:hover': {
      backgroundColor: '#538fff33',
    },
  },
  tableBody: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  dialogTitle: {
    height: '3.5rem',
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.875rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    backgroundColor: theme.palette.font.white,
  },
  dialogText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  dialogRound: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    marginRight: '0.938rem',
  },
  dialogDropIcon: {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
  },
  paper: {
    padding: '0.938rem 0.875rem 0.938rem 0.938rem',
    borderRadius: '2.7px',
    boxShadow: '0 0 16px 0 rgba(125, 134, 169, 0.2)',
    '& >button:last-child': {
      margin: 0,
    },
  },
  popover: {
    marginTop: '1rem',
    '& .MuiPopover-paper': {
      overflow: 'visible',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  tableListBody: {
    maxHeight: '10rem',
    overflow: 'auto',
  },
}));

export function Week(monday) {
  const weekInit = [{}, {}, {}, {}, {}, {}, {}];
  for (let i = 0; i < 7; i++) {
    weekInit[i].date = moment(monday).add(i, 'd').date();
  }

  return _.map(weekInit, (item) => {
    const todayDate = moment().date();
    if (
      moment(monday).format('DD/MM/YYYY') === moment(moment().isoWeekday(1)).format('DD/MM/YYYY') &&
      item.date === todayDate
    ) {
      return {
        ...item,
        mark: true,
      };
    }
    return {
      ...item,
    };
  });
}

function RelievingPlanning({ wardId, rouList }) {
  const classes = useStyles();
  const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
  const [selectDate, setSelectDate] = useState(dutyDateInfo?.date ?? moment());
  const [thisMonday, setThisMonday] = useState(moment(selectDate).isoWeekday(1));
  const [weekList, setWeekList] = useState(Week(thisMonday));
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogDrop, setDialogDrop] = useState(null);
  const dialogDropOpen = Boolean(dialogDrop);
  const [weekDay, setWeekDay] = useState({
    start: moment(selectDate).isoWeekday(1).format('D/M/YYYY'),
    end: moment(selectDate).isoWeekday(7).format('D/M/YYYY'),
  });
  const [dropIndex, setDropIndex] = useState(null);
  const [stsStaff, setSrsStaff] = useState([]);
  const [settingData, setSettingData] = useState([]);

  // get srsStaff API
  const getSrsStaffAPI = async ({ timeStart, timeEnd }) => {
    try {
      const { result } = await dutyAssignAPI.getSrsStaffList({ wardId, timeStart, timeEnd });
      setSrsStaff([...result.roster_list]);
    } catch (error) {
      console.log('-----Get SrsStaff error----->', error);
    }
  };

  // get setting API
  const getSettingAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getRelievintSetting();
      setSettingData(result);
    } catch (error) {
      console.log('-----Get Setting Detail error----->', error);
    }
  };

  // save setting API
  const saveSettingAPI = async ({ options }) => {
    try {
      await dutyAssignAPI.postSaveRelievintSetting({ options });
      await getSettingAPI();
      setDialogDrop(null);
    } catch (error) {
      console.log('-----Save Setting error----->', error);
    }
  };

  useEffect(() => {
    if (!dutyDateInfo) {
      sessionStorage.setItem('dutyInfo', JSON.stringify({ date: moment(), id: -1, index: 0 }));
    }
    (async () => {
      await getSrsStaffAPI({
        timeStart: moment(weekDay.start, 'D/M/YYYY').format('YYYY-MM-DD'),
        timeEnd: moment(weekDay.end, 'D/M/YYYY').format('YYYY-MM-DD'),
      });
    })();

    (async () => {
      await getSettingAPI();
    })();
  }, [weekDay, rouList]);

  const settingList = useMemo(() => {
    let list = [];

    if (Array.isArray(settingData) && settingData.length > 0) {
      list = _.map(settingData, (item) => {
        return {
          text: item.option,
          color: item.colour,
        };
      });
    }

    return list;
  }, [settingData]);

  const handleSearchCode = (data, number) => {
    const arrayItem = _.find(data, [
      'shift_date',
      moment(weekDay.start, 'D/M/YYYY').add(number, 'd').format('YYYY-MM-DD'),
    ]);
    let code = '';
    let add = false;

    if (arrayItem) {
      code = arrayItem.shift_code;
    }

    if (
      _.findIndex(leaveCode, (item) => {
        return item === String(code);
      }) > -1
    ) {
      add = true;
    }

    return { code, add };
  };

  const rows = useMemo(() => {
    let groupList = [];
    let list = [];

    if (Array.isArray(stsStaff) && stsStaff.length > 0) {
      groupList = _.groupBy(stsStaff, 'staff_key');

      list = _.map(groupList, (item) => {
        let leave = 0;
        let mon = handleSearchCode(item, 0).code;
        let tue = handleSearchCode(item, 1).code;
        let wed = handleSearchCode(item, 2).code;
        let thu = handleSearchCode(item, 3).code;
        let fri = handleSearchCode(item, 4).code;
        let sat = handleSearchCode(item, 5).code;
        let sun = handleSearchCode(item, 6).code;

        for (let i = 0; i < 7; i++) {
          if (handleSearchCode(item, i).add) {
            leave += 1;
          }
        }

        return {
          name: item[0].staff_name,
          leave,
          mon,
          tue,
          wed,
          thu,
          fri,
          sat,
          sun,
        };
      });
    }

    return list;
  }, [stsStaff]);

  const columns = [
    { id: 'name', label: i18n.t('DUTYASSIGN_RELIEVING_NAME'), style: { width: '23rem', minWidth: '23rem' } },
    { id: 'leave', label: i18n.t('DUTYASSIGN_RELIEVING_LEAVE'), style: { width: '7.938rem' }, align: 'center' },
    {
      id: 'mon',
      label: i18n.t('DUTYASSIGN_RELIEVING_MON'),
      weekDay: weekList[0].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[0].mark,
    },

    {
      id: 'tue',
      label: i18n.t('DUTYASSIGN_RELIEVING_TUE'),
      weekDay: weekList[1].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[1].mark,
    },
    {
      id: 'wed',
      label: i18n.t('DUTYASSIGN_RELIEVING_WED'),
      weekDay: weekList[2].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[2].mark,
    },
    {
      id: 'thu',
      label: i18n.t('DUTYASSIGN_RELIEVING_THU'),
      weekDay: weekList[3].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[3].mark,
    },

    {
      id: 'fri',
      label: i18n.t('DUTYASSIGN_RELIEVING_FRI'),
      weekDay: weekList[4].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[4].mark,
    },
    {
      id: 'sat',
      label: i18n.t('DUTYASSIGN_RELIEVING_SAT'),
      weekDay: weekList[5].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[5].mark,
    },
    {
      id: 'sun',
      label: i18n.t('DUTYASSIGN_RELIEVING_SUN'),
      weekDay: weekList[6].date,
      style: { width: '7.938rem' },
      align: 'center',
      mark: weekList[6].mark,
    },
  ];

  function DateFormat() {
    return `${weekDay.start}-${weekDay.end}`;
  }

  const handleToday = () => {
    const monday = moment().isoWeekday(1);
    weekDay.start = monday.format('D/M/YYYY');
    weekDay.end = moment(monday).isoWeekday(7).format('D/M/YYYY');
    setThisMonday(monday);
    setWeekDay({ ...weekDay });
    setWeekList([...Week(monday)]);
    setSelectDate(moment());
    sessionStorage.setItem('dutyInfo', JSON.stringify({ date: moment(), id: -1, index: 0 }));
  };

  const handlePreviousWeek = () => {
    const monday = moment(thisMonday).isoWeekday(-6);
    weekDay.start = monday.format('D/M/YYYY');
    weekDay.end = moment(monday).isoWeekday(7).format('D/M/YYYY');
    setThisMonday(monday);
    setWeekDay({ ...weekDay });
    setWeekList([...Week(monday)]);
  };

  const handleNextWeek = () => {
    const monday = moment(thisMonday).isoWeekday(8);
    weekDay.start = monday.format('D/M/YYYY');
    weekDay.end = moment(monday).isoWeekday(7).format('D/M/YYYY');
    setThisMonday(monday);
    setWeekDay({ ...weekDay });
    setWeekList([...Week(monday)]);
  };

  const colorFormat = (props) => {
    const data = settingList.find((item) => item.text === props);
    return data === undefined ? null : data.color;
  };

  const handleChangeColor = (color) => {
    let list = settingData;

    if (Array.isArray(list) && list.length > 0) {
      if (list[dropIndex].colour === color) {
        list[dropIndex].colour = '#2e4469';
        (async () => {
          await saveSettingAPI({
            options: _.map(list, (item) => {
              return {
                option: item.option,
                colour: item.colour,
              };
            }),
          });
        })();
        return;
      }
      list[dropIndex].colour = color;
      (async () => {
        await saveSettingAPI({
          options: _.map(list, (item) => {
            return {
              option: item.option,
              colour: item.colour,
            };
          }),
        });
      })();
    }
  };

  const handleSelectDate = (value) => {
    setSelectDate(value);
    if (moment(value).isBetween(moment('1976-01-01', 'yyyy-MM-DD'), moment('9999-12-31', 'yyyy-MM-DD'))) {
      const monday = moment(value).isoWeekday(1);
      setThisMonday(monday);
      setWeekDay({
        start: moment(monday).format('D/M/YYYY'),
        end: moment(monday).isoWeekday(7).format('D/M/YYYY'),
      });
      setWeekList([...Week(monday)]);
      sessionStorage.setItem('dutyInfo', JSON.stringify({ date: value, id: -1, index: 0 }));
    }
  };

  return (
    <div>
      <Header text={i18n.t('DUTYASSIGN_BACK')} path={rou.dutyassignRou.path} id="3" />
      <div className={classes.body}>
        <Head
          id="4"
          DateStr={DateFormat}
          handleToday={handleToday}
          handlePreviousWeek={handlePreviousWeek}
          handleNextWeek={handleNextWeek}
          title={i18n.t('DUTYASSIGN_RELIEVING_TITLE')}
        >
          <DatePicker handleSelectDate={handleSelectDate} selectDate={selectDate} id="DutyAssign-DatePicker-aep" />
          <ButtonBase id="5" className={classes.headBtn} onClick={() => setDialogOpen(true)}>
            <SettingIcon style={{ fontSize: '1.25rem', color: '#ffffff', marginRight: '0.5rem' }} />
            {i18n.t('DUTYASSIGN_SETTING')}
          </ButtonBase>
          <Dialog
            open={dialogOpen}
            closeID="DutyAssign-Dialog-aeq"
            title={i18n.t('DUTYASSIGN_SETTING')}
            handleClose={() => setDialogOpen(false)}
            dialogfootStyle={{ display: 'none' }}
          >
            <TableContainer className={classes.setting}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_RELIEVING_OPTION')}</TableCell>
                    <TableCell align="right" className={classes.dialogTitle}>
                      {i18n.t('DUTYASSIGN_RELIEVING_COLOUR')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {settingList.map((item, index) => {
                    return (
                      <TableRow key={item?.text}>
                        <TableCell className={classes.dialogText}>{item['text']}</TableCell>
                        <TableCell align="right">
                          <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row-reverse' }}>
                            <ButtonBase
                              onClick={(event) => {
                                if (Array.isArray(settingData) && settingData.length === 0) {
                                  (async () => {
                                    await getSettingAPI();
                                  })();
                                }
                                setDialogDrop(event.currentTarget);
                                setDropIndex(index);
                              }}
                              id={`DutyAssign-ButtonBase-aer-${index}`}
                            >
                              <DropDownIcon className={classes.dialogDropIcon} />
                            </ButtonBase>
                            <div
                              style={{
                                backgroundColor: item['color'],
                              }}
                              className={classes.dialogRound}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Popover
              anchorEl={dialogDrop}
              open={dialogDropOpen}
              id="DutyAssign-Popover-aes"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              onClose={() => {
                setDialogDrop(null);
              }}
              className={classes.popover}
            >
              <Paper className={classes.paper}>
                <ButtonBase
                  className={classes.dialogRound}
                  onClick={() => {
                    handleChangeColor('#000000');
                  }}
                  id="DutyAssign-ButtonBase-aet"
                  style={{ backgroundColor: '#000000' }}
                />
                <ButtonBase
                  className={classes.dialogRound}
                  onClick={() => {
                    handleChangeColor('#7b80ff');
                  }}
                  id="DutyAssign-ButtonBase-aeu"
                  style={{ backgroundColor: '#7b80ff' }}
                />
                <ButtonBase
                  className={classes.dialogRound}
                  onClick={() => {
                    handleChangeColor('#ff7270');
                  }}
                  id="DutyAssign-ButtonBase-aev"
                  style={{ backgroundColor: '#ff7270' }}
                />
                <ButtonBase
                  className={classes.dialogRound}
                  onClick={() => {
                    handleChangeColor('#28d2ab');
                  }}
                  id="DutyAssign-ButtonBase-aew"
                  style={{ backgroundColor: '#28d2ab' }}
                />
              </Paper>
            </Popover>
          </Dialog>
        </Head>
        <div className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => {
                    return column.weekDay ? (
                      <TableCell
                        key={column.weekDay}
                        align={column.align}
                        style={column.style}
                        className={classes.title}
                      >
                        <div
                          style={
                            column.mark
                              ? {
                                  backgroundColor: '#538fff',
                                  color: '#fff',
                                  borderRadius: '50%',
                                  width: '1.75rem',
                                  height: '1.75rem',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  margin: '0 auto',
                                }
                              : {}
                          }
                        >
                          {column.weekDay}
                        </div>
                        {column.label}
                      </TableCell>
                    ) : (
                      <TableCell key={column.label} align={column.align} style={column.style} className={classes.title}>
                        {column.label}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => {
                  return (
                    <TableRow key={JSON.stringify(row)} className={classes.tableTr}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className={classes.tableBody}
                            style={{ color: colorFormat(value) }}
                          >
                            {value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  wardId: state.loginInfo.wardId,
  rouList: state.rouList,
});

export default connect(mapStateToProps)(RelievingPlanning);
